import { Utilities } from "@tylertech/shared-module";
import { PredicateFunction } from "../interfaces";
export class ArrayHelpers
{
    /**
     * @deprecated - use Array.find
     */
    static first<T>(values: T[], predicate: PredicateFunction<T> = null): T
    {
        if (!values)
            return null;
        if (predicate)
        {
            const first = values.find(predicate);
            if (!Utilities.IsNullOrUndefined(first))
                return first;
        }
        else if (values.length > 0)
            return values[0];
        return null;
    }

    /**
     * @deprecated - just test the list's length
     */
    static any<T>(list: T[]): boolean;
    /**
     * @deprecated - use Array.every
     */
    static any<T>(list: T[], predicate: PredicateFunction<T>): boolean;
    static any<T>(list: T[], predicate?: PredicateFunction<T>): boolean
    {
        if (!list || list.length === 0)
        {
            return false;
        }
        if (!predicate)
        {
            return true; // we have a array, and it's length MUST be greater than 0
        }
        for (const item of list)
        {
            if (predicate(item))
            {
                return true;
            }
        }
        return false;
    }

    static none<T>(list: T[], predicate?: PredicateFunction<T>): boolean
    {
        if (!list || list.length === 0)
        {
            return true;
        }
        if (!predicate)
        {
            return list.length === 0;
        }
        for (const item of list)
        {
            if (predicate(item))
            {
                return false;
            }
        }
        return true;
    }
}
